import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';
import usePopoverState from 'Hooks/usePopoverState';
import { ThreadFiltersMenuPopover }
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters/components/ThreadFiltersMenu/components/ThreadFiltersMenuPopover';
import classNames from 'classnames';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { getBorder } from 'Components/utils';
import { fade } from '@material-ui/core/styles/colorManipulator';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { DataValueMap } from 'Helpers/Testing';
import useUserContext from 'Context/UserContext';

const useStyles = buildUseStyles('ThreadFiltersMenu', (theme) => ({
  root: {
    padding: theme.spacing(0.5),
  },
  button: {
    // Added so buttons don't shift when changing to contained
    ...getBorder(
      theme,
      {
        all: true,
        color: fade(theme.palette.primary.main, 0.5),
      },
    ),
    margin: 0,
    flex: 'initial',
    width: 'initial',
    padding: theme.spacing(0.5, 2),
    height: theme.spacing(4.5),
  },
  icon: {
    height: theme.spacing(2.25),
  },
}));

const ThreadFiltersMenuButton = ({
  className,
  onChange,
  numberOfSelectedFilters,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { isAgent } = useUserContext();

  const hasSelectedFilters = numberOfSelectedFilters > 0;

  const {
    open,
    anchorEl,
    openPopover,
    handleClose: handlePopoverClose,
    handleEnter,
  } = usePopoverState({});

  return (
    <React.Fragment>
      { isAgent
        ? (
          <RoundedButton
            className={classNames(className, classes.button)}
            onClick={(event) => {
              event.stopPropagation();
              return openPopover(event);
            }}
            endIcon={<KeyboardArrowDownIcon />}
            color={'primary'}
            variant={hasSelectedFilters ? 'contained' : 'outlined'}
            padding={'none'}
            test={'messages-page-thread-type-filters-menu-button'}
          >
            <Typography variant={'subtitle2'} weight={'bold'}>
              {hasSelectedFilters ? `Filters (${numberOfSelectedFilters})` : 'Filters'}
            </Typography>
          </RoundedButton>)
        : (<IconButton
          className={classNames(className, classes.root)}
          color={'primaryGray'}
          variant={'text'}
          padding={'none'}
          title={'More Options'}
          {...DataValueMap.init('messages-page-thread-type-filters-menu-button').build()}
          disableRipple
          onClick={(event) => {
            event.stopPropagation();
            return openPopover(event);
          }}
          icon={MoreVertIcon}
        />)
      }
      <ThreadFiltersMenuPopover anchorEl={anchorEl} handleEnter={handleEnter} handleClose={handlePopoverClose} open={open} onChange={onChange} />
    </React.Fragment>
  );
};

ThreadFiltersMenuButton.defaultProps = {
  className: '',
  onChange: noop,
  numberOfSelectedFilters: 0,
};

ThreadFiltersMenuButton.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  numberOfSelectedFilters: PropTypes.number,
};

export { ThreadFiltersMenuButton };
